module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"telephone_number":"Telephone Number"},"es":{"telephone_number":"Número de Teléfono"},"sw":{"telephone_number":"Namba ya Simu"}}')
  delete Component.options._Ctor
}
